// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productPriceStyles } from "@west/Overrides/Components/ProductPrice";
import { css } from "styled-components";

const unitOfMeasureText: TypographyPresentationProps = {
    size: 12,
    lineHeight: "16px",
    color: "common.ui6",
    transform: "capitalize",
    css: css`
        white-space: nowrap;
    `,
};

productPriceStyles.priceWrapper = {
    css: css`
        ${wrapInContainerStyles}
        display: flex;
        align-items: baseline;
        gap: 4px;
    `,
};

productPriceStyles.price = {
    priceText: {
        forwardAs: "p",
        variant: "h3",
        color: "common.ui6",
        css: css`
            margin: 0;
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText,
    },
    errorText: { weight: "bold", size: 14 },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    vatLabelText: {
        css: css`
            font-size: 12px;
        `,
    },
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText,
};
